import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	closeButtonLabel: {
		id: 'color-picker.color-picker-dropdown.close-button-label',
		description: 'Accessible label of the button that closes the dropdown of the color picker',
		defaultMessage: 'Close',
	},
	headerText: {
		id: 'color-picker.color-picker-dropdown.header-text',
		description:
			'Header of color picker dropdown for customizing highlight and background colors of navigation',
		defaultMessage: 'Select a color',
	},
	resetButtonText: {
		id: 'color-picker.color-picker-dropdown.reset-button-text',
		description:
			'Button text on click resets color picker dropdown value to default blue or white for highlight and background color pickers respectively',
		defaultMessage: 'Reset to default',
	},
});
